import { useActiveAgent } from "../contexts/ActiveAgentContext";
import dayjs from "../utils/dayjs";

// if the user is viewing the dashboard in a different timezone than their restaurant (it defaults to showing the user's timezone
// we need to display it in the restaurant's timezone, use this file to do that
export const useFormattedDate = () => {
  const { activeAgent } = useActiveAgent();
  const timezone = activeAgent?.timezone;

  const formatWithTimezone = (timestamp: string, format: string) => {
    return timezone
      ? dayjs(timestamp).tz(timezone).format(format)
      : dayjs(timestamp).format(format);
  };

  const formatTime = (timestamp: string) => {
    // "1:00 PM"
    return formatWithTimezone(timestamp, "h:mm A");
  };

  const formatTimeWithSeconds = (timestamp: string) => {
    // "1:00:30 PM"
    return formatWithTimezone(timestamp, "h:mm:ss A");
  };

  const formatDateShort = (timestamp: string) => {
    // "Jun 9"
    return formatWithTimezone(timestamp, "MMM D");
  };

  const formatDate = (timestamp: string) => {
    // "June 9"
    return formatWithTimezone(timestamp, "MMMM D");
  };

  const formatDateLong = (timestamp: string) => {
    // "Monday, June 9"
    return formatWithTimezone(timestamp, "dddd, MMMM D");
  };

  // 4:35 PM, July 6th
  const formatDateTime = (timestamp: string): string => {
    return formatWithTimezone(timestamp, "h:mm A, MMM. D");
  };

  const formatDateTimeLong = (timestamp: string) => {
    // "Monday, June 9, 1:00 PM"
    return formatWithTimezone(timestamp, "dddd, MMMM D, h:mm A");
  };

  const formatTimeAgo = (timestamp: string) => {
    // "1 minute ago"
    return timezone
      ? dayjs(timestamp).tz(timezone).fromNow()
      : dayjs(timestamp).fromNow();
  };

  return {
    formatTime,
    formatTimeWithSeconds,
    formatDate,
    formatDateShort,
    formatDateLong,
    formatDateTime,
    formatDateTimeLong,
    formatTimeAgo,
    timezone,
  };
};
